import React, { useEffect, useState } from 'react';
import userType from '../../../types/userType';
import useAPI from '../../../hooks/useAPI';
import useUserRole from '../../../hooks/useUserRole';

interface UserTableProps {
    users?: userType[];
    onRefresh: () => void;
}

function UserTable(props: Readonly<UserTableProps>) {
    const { users = [], onRefresh } = props;
    const [filter, setFilter] = useState('');
    const { currentUser } = useUserRole();
    const { Delete, Put } = useAPI();

    useEffect(() => {
        function handleFilter(e: Event) {
            setFilter((e as CustomEvent<string>).detail);
        }
        globalThis.addEventListener('filter', handleFilter);
        return () => globalThis.removeEventListener('filter', handleFilter);
    }, []);

    const filteredUsers = users.filter((u) =>
        u.name.toLowerCase().includes(filter.toLowerCase()),
    );

    const handleToggleAdmin = async (user: userType) => {
        try {
            await Put(`/admin/users/${user.id}/admin`, { ...user, roles: user.roles.includes("ROLE_ADMIN") ? user.roles.filter(role => role !== "ROLE_ADMIN") : [...user.roles, "ROLE_ADMIN"] });
            onRefresh();
        } catch (error) {
            globalThis.dispatchEvent(
                new CustomEvent('ShowAlert', {
                    detail: {
                        label: error instanceof Error ? error.message : 'Er is een fout opgetreden',
                        type: 'Warning',
                    },
                }),
            );
        }
    };

    const handleDelete = async (id: number) => {
        try {
            await Delete(`/admin/users/${id}`);
            onRefresh();
            globalThis.dispatchEvent(
                new CustomEvent('ShowAlert', {
                    detail: { label: 'Gebruiker is succesvol verwijderd', type: 'Success' },
                }),
            );
        } catch (error) {
            globalThis.dispatchEvent(
                new CustomEvent('ShowAlert', {
                    detail: {
                        label: error instanceof Error ? error.message : 'Gebruiker is niet verwijderd',
                        type: 'Warning',
                    },
                }),
            );
        }
    };

    return (
        <table className="o-user-table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th className='admin-column'>Admin</th>
                    <th>Verwijderen</th>
                </tr>
            </thead>
            <tbody>
                {filteredUsers.map((user) => (
                    <tr key={user.id}>
                        <td>{user.name}</td>
                        <td>
                            <label htmlFor={`admin-${user.id}`}>
                                <input
                                    id={`admin-${user.id}`}
                                    type="checkbox"
                                    aria-label="Admin"
                                    checked={user.roles.includes("ROLE_ADMIN")}
                                    disabled={user.id === currentUser?.id}
                                    onChange={() => handleToggleAdmin(user)}
                                />
                            </label>
                        </td>
                        <td>
                            <button
                                type="button"
                                className={`o-user-table__delete-btn ${user.id === currentUser?.id ? "current-user" : ""}`}
                                onClick={() => handleDelete(user.id)}
                                disabled={user.id === currentUser?.id}
                            >
                                Verwijderen
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

UserTable.defaultProps = {
    users: [],
};

export default UserTable;
